import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { LocaleService } from './locale.service';

export const localeHttpInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiBaseUrl)) {
    return next(req);
  }

  const locale = inject(LocaleService);
  return next(
    req.clone({
      setHeaders: {
        'Accept-Language': locale.acceptLanguageHeader(),
      },
    }),
  );
};
